import React from 'react';
import HiddenInput from 'shared/components/HiddenInput';

const CombinedSelected = ({ parameters, groupName }) => {
  const name = 'combined_selected';
  return (
    <HiddenInput
      name={name}
      value={parameters[name]}
      groupName={groupName} />
  );
};

export default CombinedSelected;
